import React from "react";
import { useTranslation } from 'react-i18next';
function Deliveredsearch(props) { 
  const { t } = useTranslation(); 
  return (
<input type="search" placeholder={t('search_invoice_no')} value={props.searchTerm} onChange={props.handleInputChange}/>
);
}

export default Deliveredsearch;
